import React, { useEffect, useState } from 'react';
import { fetchMovementsHistory } from '../services/db';
import { StockMovement } from '../types';
import { useI18n } from '../i18n';

type MovementWithMeta = StockMovement & { sku: string; productName: string };

export const Reports: React.FC = () => {
  const [history, setHistory] = useState<MovementWithMeta[]>([]);
  const [loading, setLoading] = useState(true);
  const { t } = useI18n();

  useEffect(() => {
    fetchMovementsHistory().then(data => {
      setHistory(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="space-y-4 text-primary">
      <div className="bg-surface p-4 rounded-xl shadow-sm border border-subtle">
        <h2 className="text-lg font-bold text-primary">{t('reports.title')}</h2>
        <p className="text-xs text-muted mt-1">{t('reports.subtitle')}</p>
      </div>

      {loading ? (
        <div className="flex justify-center p-8 text-muted">{t('reports.loading')}</div>
      ) : history.length === 0 ? (
        <div className="text-center p-8 text-muted">{t('reports.empty')}</div>
      ) : (
        <div className="space-y-2">
          {history.map((m) => (
            <div key={m.id} className="bg-surface p-3 rounded-lg shadow-sm border border-subtle flex items-center justify-between">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded border ${
                    m.type === 'IN'
                      ? 'bg-success-soft text-success border-success'
                      : m.type === 'OUT'
                        ? 'bg-danger-soft text-danger border-danger'
                        : 'bg-accent-soft text-accent border-accent'
                  }`}>
                    {m.type}
                  </span>
                  <span className="text-xs text-muted">{new Date(m.created_at).toLocaleString()}</span>
                </div>
                <div className="font-medium text-primary text-sm truncate">{m.sku}</div>
                <div className="text-xs text-muted truncate">{m.productName}</div>
              </div>
              <div className="text-right pl-3">
                 <div className={`text-lg font-bold ${
                   m.type === 'IN' ? 'text-success' : m.type === 'OUT' ? 'text-danger' : 'text-accent'
                 }`}>
                   {m.type === 'OUT' ? '-' : '+'}{Math.abs(m.quantity)}
                 </div>
                 {m.reason && <div className="text-[10px] text-muted">{m.reason}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};